import { IClientConfigs, VehicleConsumableGroup } from '~/shared';
import { createSlice } from '../wrappers';

export enum StageTypes {
	Category = 'category',
	List = 'list',
	Settings = 'settings',
}

interface VehicleServiceSlice {
	activeStage: StageTypes;
	activeCategory: VehicleConsumableGroup | 'engine' | null;
	activeList: IClientConfigs['vehicleWear']['consumables'];
	activeListIndex: number | null;
	maxListIndex: number;
	displayedEngineHealth: number | null;
	displayedConsumablesHealth: Partial<
		Record<VehicleConsumableGroup, number>
	> | null;
}

const initialState: VehicleServiceSlice = {
	activeStage: StageTypes.Category,
	activeCategory: null,
	activeList: [] as IClientConfigs['vehicleWear']['consumables'],
	activeListIndex: null,
	maxListIndex: 0,
	displayedEngineHealth: null,
	displayedConsumablesHealth: null,
};

const vehicleServiceSlice = createSlice({
	name: 'vehicleService',
	initialState,
	reducers: {
		setActiveStage: (state, action) => {
			state.activeStage = action.payload;
		},
		setActiveListIndex: (state, action) => {
			state.activeListIndex = action.payload;
		},
		setMaxListIndex: (state, action) => {
			state.maxListIndex = action.payload;
		},
		setActiveList: (state, action) => {
			state.activeList = action.payload;
		},
		setActiveCategory: (state, action) => {
			state.activeCategory = action.payload;
		},
		setDisplayedEngineHealth: (state, action) => {
			state.displayedEngineHealth = action.payload;
		},
		setDisplayedConsumablesHealth: (state, action) => {
			state.displayedConsumablesHealth = action.payload;
		},
	},
});

export const {
	setActiveStage,
	setActiveListIndex,
	setMaxListIndex,
	setActiveList,
	setActiveCategory,
	setDisplayedEngineHealth,
	setDisplayedConsumablesHealth,
} = vehicleServiceSlice.actions;

export default vehicleServiceSlice.reducer;
